module.exports = __webpack_public_path__ + "assets/img/d5ceda78a682bc6b6a4cef12fd8d3afd.svg";